import { createContext } from 'react';
import { GenerateReportFn } from 'apps/sigma2-ui/src/reports/hooks/types';
import { PendingReportInfo } from 'apps/sigma2-ui/src/reports/hooks/types';

export interface ReportsContext {
  exportReport: GenerateReportFn;
  pendingReports: PendingReportInfo[];
  removePendingReport: (reportId: string) => void;
}

export const ReportsContext = createContext<ReportsContext>({
  exportReport: () => {},
  pendingReports: [],
  removePendingReport: () => {},
});
